module.exports = __webpack_public_path__ + "img/no_invite.38c6e3de.svg";